import { PARTNER_TEXT } from "./views/partners/texts.js";

/**
 * Das NEULADEN des Fensters nach einem Unternehmenswechsel (Spec Mandantentrennung, R4) — als
 * Objekt, damit Tests es ersetzen können (jsdom kennt keine Navigation). Ohne Pfad lädt die Seite
 * neu; mit Pfad wird sie ersetzt (kein zusätzlicher Verlaufseintrag). Ob der Browser dem Neuladen
 * widerspricht, entscheidet der Aufrufer: Hat der Verlassen-Wächter gefragt, gibt er das Verlassen
 * vorher frei (`verlassenFreigeben` in `@kundeninfo/ui`); sonst bleibt der Schutz der offenen Maske.
 */
export const fenster = {
  neuLaden(pfad?: string): void {
    if (pfad === undefined) window.location.reload();
    else window.location.replace(pfad);
  },
};

/**
 * Der REITERTITEL des Fensters (Spec „Wortwahl“: „Akte“ im Fenstertitel; Lieferanten Aufgabe 22): das Präfix der Welt
 * („[TEST] “), bei offener Akte „Akte ‹Firma› – “ — die Akte ist die eines Geschäftspartners jeder Rolle, nicht mehr die
 * „Kundenakte“ —, dann der Name der Anwendung.
 */
export function windowTitle(prefix: string, application: string, record: string | null): string {
  return `${prefix}${record === null ? "" : `${PARTNER_TEXT.recordTitle(record)} – `}${application}`;
}
